export const es_valutation = {
    title: 'Valutazioni',
    body: 'Crea una nuova tabella di valutazione di una macrozona per determinare velocemente lo <strong>street price</strong>.',
    button: 'Crea e Gestisci',
    label_map: 'Seleziona la regione',
    label_select: 'Seleziona la città e le zone di riferimento',
    label_add_price: 'Aggiungi prezzo e mq per ',
    label_city: 'Ciudad',
    label_macrozone: 'Macro zona',
    label_zone: 'Zona',
    label_microzone: 'Micro zona',
    label_button: 'Aggiungi',
    label_price: 'Prezzo',
    label_mq: 'Mq',
    label_average: 'Prezzo/Mq',
    label_address: 'Dirección',
    label_room: 'Locales',
    label_lift:'Ascensor',
    label_bathroom: 'Baño',
    label_renovation: 'Reformas',
    label_date: 'Data',
    label_link: 'Link',
    label_piano: 'Planta',
    label_link_l:'Ir al anuncio',
    label_mapping_link: 'Link de mapeo',
    label_mapping_link_l: 'Ir al mapeo',
    label_note: 'Nota',
    label_table_valutation: 'Tabella di valutazione',
    valutation_question_title: 'Conferma cancellazione',
    valutation_question_delete: 'Sei sicuro di voler cancellare questa risorsa?',
    valutation_label_button_close: 'No, Cambié de opinión',
    valutation_label_button_delete: 'Sì, ELIMINAR',
    average_price_size: 'Media prezzo/mq',
    region: 'Regione',
    count: 'Tabelle',
    street_price: 'Street Price',
    label_table_archive_city: 'Città',
    label_archive: 'Archivio Tabelle',
    valued_zones: 'Zone valutate',
    label_bread_crumb_subzone: 'Zone di ',
    label_streetprice: 'Inserisci prezzo e mq',
    back:'Indietro',
    label_immobiliare_it: 'Valore Immobiliare.it',
    label_borsinoimmobiliare_it: 'Valore Borsinoimmobiliare.it',
    label_save:'salva ficha operación',
    label_export:'exporta pdf',
    label_configure:'configura ec',
    label_delete:'Borra ec',
    label_peggiore:'Peor',
    label_medio:'Medio',
    label_migliore:'Mejor',
    label_consuntivo:'Balance',


    popover_city_zone_title: 'Valuta i tuoi immobili',
    popover_city_zone_content: '<p>In questa card puoi creare la tua tabella di valutazione degli immobili suddivisi per zona. Inserisci prima di tutto la <strong>città</strong>, poi la zona. Sono facoltativi macro e micro zona.</p> \n' +
        '\n' +
        '<p>Quando avrai completato questi campi, sarai pronto per inserire <strong>prezzo</strong> e <strong>metri quadri</strong> di ogni singolo immobile che dovrai valutare. L\'applicazione calcolerà in autonomia il prezzo al metro quadro e verrà determinato automaticamente lo street price in quella zona.</p>\n' +
        '\n',

    popover_archive_table_title: 'Il tuo archivio',
    popover_archive_table_content: '<p>In questa card puoi selezionare e gestire le tabelle di valutazione create. In base alla regione selezionata sulla mappa.</p>',

    popover_list_title: 'Immobili da valutare',
    popover_list_content: '<p>In questa card potrai avere subito disponibili la media prezzo al mq e lo <strong>Street Price</strong> che sarà utile a determinare il prezzo di acquisto in quella zona.</p>\n' +
        '\n' +
        '<p>In più potrai inserire la valutazione degli immobili dalle piattaforme immobiliare.it e borsino immobiliare in modo da confrontarli con i prezzi di vendita inseriti.</p>\n',


};
